import { POPUP_DEPTH } from '@constants/common.const';
import { SceneKey } from '@models/scene-keys';
import Phaser from 'phaser';

export default class Error extends Phaser.Scene {
  constructor() {
    super(SceneKey.Error);
  }

  private bg!: Phaser.GameObjects.Rectangle;
  private image!: Phaser.GameObjects.Image;

  create(data: { error?: string } = {}) {
    const error = data.error || 'Unknown error occurred';
    console.log('ERROR', error);

    this.buildUI();

    this.scene.bringToTop();

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
    this.scale.on('resize', this.handleResize, this);
  }

  private buildUI(): void {
    const { width, height } = this.scale;

    this.bg = this.add
      .rectangle(0, 0, width, height, 0x001769, 1)
      .setOrigin(0, 0)
      .setDepth(POPUP_DEPTH)
      .setScrollFactor(0);

    this.image = this.add
      .image(width / 2, height / 2, '404')
      .setOrigin(0.5)
      .setDepth(POPUP_DEPTH + 1)
      .setScrollFactor(0);

    this.scaleImage();
  }

  private scaleImage(): void {
    const { width } = this.scale;
    this.image.setDisplaySize(
      width * 0.8,
      width * 0.8 * (this.image.height / this.image.width),
    );
  }

  private handleResize() {
    if (!this.scene?.isActive()) return;

    const { width, height } = this.scale;
    this.bg.setSize(width, height);
    this.image.setPosition(width / 2, height / 2);
    this.scaleImage();
  }

  shutdown() {
    this.scale.off('resize', this.handleResize, this);
  }
}
